import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Button from '../../sharedLegacy/components/ButtonComponent/ButtonComponent'
import RadioButtonComponent from '../../sharedLegacy/components/RadioButtonComponent/RadioButtonComponent'
import { useWebinarColors } from '../../Designs/blocs/useWebinarColors'
import type { Poll } from '../model/Poll'

import { PollQuestion } from './PollQuestion'
import { usePollsContext } from './PollsContext'

import './PollVote.scss'

type PollVoteProps = {
  poll: Poll
}

export const PollVote = ({ poll }: PollVoteProps) => {
  const { accent, tabs } = useWebinarColors()
  const { answerPoll } = usePollsContext()

  const [selected, setSelected] = useState<number | null>(null)

  const isButtonDisabled = selected === null

  const radioButtonStyles = {
    text: { fontSize: 12 },
    passiveColor: tabs.highContrast.color,
    activeColor: accent.color,
  }

  const onVote = () => {
    if (selected === null) {
      return
    }

    answerPoll(poll, selected, window.localStorage.getItem('uuid') ?? undefined)
  }

  return (
    <div className="poll-vote-component">
      <PollQuestion poll={poll} />
      {poll.options.map((option) => (
        <RadioButtonComponent
          key={option.id}
          name="answer"
          id={String(option.id)}
          checked={option.id === selected}
          label={option.option}
          onChange={() => setSelected(option.id)}
          styles={radioButtonStyles}
        />
      ))}
      <div className="vote-button-wrapper">
        <Button
          style={{
            backgroundColor: accent.color,
            color: accent.highContrast.color,
            opacity: isButtonDisabled ? 0.6 : 1,
          }}
          color="transparent"
          onClick={onVote}
          disabled={isButtonDisabled}
          className="vote-button"
          round
        >
          <FormattedMessage defaultMessage="Vote" />
        </Button>
      </div>
    </div>
  )
}
